'use client';

import Link from 'next/link';
import { Button } from '@/components/ui/button';

export default function NotFound() {
    return (
        <main className="relative min-h-screen overflow-hidden bg-white">
            {/* background glow */}
            <div className="pointer-events-none absolute -top-24 left-1/2 h-[520px] w-full -translate-x-1/2 rounded-full bg-primary/60 blur-3xl" />
            <div className="pointer-events-none absolute -bottom-24 right-[-120px] h-[420px] w-[420px] rounded-full bg-primary/10 blur-3xl" />

            <section className="mx-auto flex min-h-screen container items-center">
                <div className="grid w-full gap-10 lg:grid-cols-2 lg:items-center">
                    {/* Left */}
                    <div>
                        <h1 className="mt-6 font-bold fs-66 text-foreground sm:text-5xl">
                            This page is missing…
                            <span className="block text-primary">
                                but your publishing dream isn’t.
                            </span>
                        </h1>

                        <p className="mt-4 text-lg leading-8 text-gray-700">
                            The link may be broken or the page may have been moved. Use the options
                            below to get back on track.
                        </p>

                        <div className="mt-8 flex flex-wrap gap-3">
                            <Link href="/">
                                <Button key="chat" type="button" variant="default" size="2xl">
                                    Back to Home
                                </Button>
                            </Link>

                            <Link href="/contact-us">
                                <Button key="chat" type="button" variant="secondary" size="2xl">
                                    Contact Us
                                </Button>
                            </Link>
                        </div>

                        {/* quick links */}
                        {/* <div className="mt-10">
                            <p className="text-sm font-semibold text-gray-900">Popular pages</p>
                            <div className="mt-3 flex flex-wrap gap-2">
                                {[
                                    { label: 'About Us', href: '/about-us' },
                                    { label: 'Our Work', href: '/case-studies' },
                                    { label: 'Blog', href: '/blog' },
                                ].map((item) => (
                                    <Link
                                        key={item.href}
                                        href={item.href}
                                        className="rounded-full border border-gray-200 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50"
                                    >
                                        {item.label}
                                    </Link>
                                ))}
                            </div>
                        </div> */}
                    </div>

                    {/* Right (decorative card) */}
                    <div className="relative max-w-[500px] ml-auto pt-14 mt-14">
                        <div className="rounded-3xl border border-gray-200 bg-white p-8 shadow-sm">
                            <div className="flex items-start justify-between">
                                <div>
                                    <p className="mt-2 fs-82 font-extrabold tracking-tight text-primary">
                                        404
                                    </p>
                                </div>
                            </div>

                            <div className="mt-8 space-y-3">
                                {[
                                    'Double-check the URL for typos',
                                    'Use the navigation menu to find a service',
                                    'Or contact us and we’ll help you right away',
                                ].map((t) => (
                                    <div key={t} className="flex gap-3">
                                        <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-secondary/10 text-primary">
                                            ✓
                                        </span>
                                        <p className="text-base leading-7 text-gray-700">{t}</p>
                                    </div>
                                ))}
                            </div>

                            <div className="mt-8 rounded-2xl bg-gray-50 p-5">
                                <p className="text-lg font-semibold text-gray-900">Need help?</p>
                                <p className="mt-1 text-sm leading-6 text-gray-700">
                                    Tell us what you were trying to find and we’ll point you to the
                                    right page.
                                </p>
                                <Link href="/contact-us">
                                    <Button
                                        key="chat"
                                        type="button"
                                        variant="secondary"
                                        size="2xl"
                                        className="w-full"
                                    >
                                        Contact Support
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}
